import type { Verdict, Priority } from "@/lib/mock-data";
import { useI18n } from "@/lib/i18n";

export function VerdictBadge({ verdict, size = "sm" }: { verdict: Verdict; size?: "sm" | "md" }) {
  const { t } = useI18n();
  const map: Record<Verdict, { color: string; label: string }> = {
    false: { color: "bg-verdict-false text-white", label: t("verdict.false") },
    misleading: { color: "bg-verdict-misleading text-white", label: t("verdict.misleading") },
    unproven: { color: "bg-verdict-unproven text-white", label: t("verdict.unproven") },
    true: { color: "bg-verdict-true text-white", label: t("verdict.true") },
    context: { color: "bg-verdict-context text-white", label: t("verdict.context") },
  };
  const s = map[verdict];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-sm font-bold uppercase tracking-wider ${s.color} ${
        size === "md" ? "px-2.5 py-1 text-xs" : "px-2 py-0.5 text-[10px]"
      }`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-white/80" />
      {s.label}
    </span>
  );
}

export function PriorityBadge({ priority }: { priority: Priority }) {
  const { t } = useI18n();
  const map: Record<Priority, { cls: string; label: string }> = {
    confirmed: { cls: "bg-verified text-verified-foreground", label: t("priority.confirmed") },
    developing: { cls: "bg-muted text-foreground border border-border", label: t("priority.developing") },
    correction: { cls: "bg-foreground text-background", label: t("priority.correction") },
    alert: { cls: "bg-alert text-alert-foreground", label: t("priority.alert") },
  };
  const s = map[priority];
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-sm px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${s.cls}`}>
      {s.label}
    </span>
  );
}

export function CategoryTag({ children }: { children: React.ReactNode }) {
  return (
    <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-verified">{children}</span>
  );
}
